var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 48.4057C38.031 48.4057 49 37.5697 49 24.2028C49 10.836 38.031 0 24.5 0C10.969 0 0 10.836 0 24.2028C0 37.5697 10.969 48.4057 24.5 48.4057Z",
    fill: "#2CA01C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80078 24.2027C6.80078 29.4002 11.0659 33.6155 16.3292 33.6155H17.6905V30.1173H16.3292C13.0268 30.1173 10.3399 27.4642 10.3399 24.2027C10.3399 20.9393 13.0268 18.2863 16.3292 18.2863H19.5997V36.5728C19.5997 38.5034 21.1833 40.0674 23.1389 40.0674V14.7898H16.3292C11.0659 14.7898 6.80078 19.0034 6.80078 24.2027ZM32.6673 14.7898H31.3061V18.2881H32.6673C35.9698 18.2881 38.6567 20.9411 38.6567 24.2027C38.6567 27.466 35.9698 30.119 32.6673 30.119H29.3969V11.8326C29.3969 9.90195 27.8132 8.33789 25.8559 8.33789V33.6155H32.6673C37.9289 33.6155 42.1958 29.4019 42.1958 24.2027C42.1958 19.0069 37.9289 14.7898 32.6673 14.7898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickBook);
export default __webpack_public_path__ + "static/media/quickBook.792006ec9b6a343f65c097e9b909dfd5.svg";
export { ForwardRef as ReactComponent };